module.exports = __webpack_public_path__ + "img/zh2.38d7c161.webp";